import React from 'react';

import { Button, ButtonProps } from '@fly/core';

interface FlyGithubInstallButtonProps extends Omit<
  ButtonProps,
  'iconStart' | 'onClick'
> {
  text: string;
  installationUrl: string;
}

export const FlyGithubInstallButton: React.FC<FlyGithubInstallButtonProps> = ({
  text = '',
  installationUrl = '',
  ...props
}) => {
  const onSubmit = async () => {
    window.open(installationUrl, '_top');
  };

  return (
    <Button
      data-testid='github-install-cta'
      color='accent'
      variant='solid'
      type='button'
      onClick={onSubmit}
      iconStart='github'
      size='1'
      {...props}
    >
      {text}
    </Button>
  );
};
